/**
 * Displays string which is grammatically correct based on the number of participants
 *
 * @param {number} noParticipants - The number of participants
 * @returns {string} correct grammatically string based on number of participants
 */
export function youthCampSufix(noParticipants: number): string {
	if (noParticipants === 1) {
		return '1 uczestnik';
	}

	return `${noParticipants} uczestników`;
}
